<script>

    import Value from '../$components/value.svelte'

    export let shipment = null

</script>

{#if shipment}
    <div class="title is-3">Detalles del envío</div>
    <hr>
    <div class="columns">
        <div class="column">
            <Value label="Número" value={shipment.number} prefix="#" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Proveedor" value={shipment.provider} />
        </div>
        <div class="column">
            <Value label="Servicio" value={shipment.service} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Guía" value={shipment.guide} />
        </div>
        <div class="column">
            <Value label="Documento" value="Descargar" link={shipment.document} pointer={true} />
        </div>
    </div>
    {#if shipment.secret}
        <div class="columns">
            <div class="column">
                <Value label="Código secreto" value={shipment.secret} />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="notification is-danger">
                    El paquete no podrá ser entregado sin el código secreto, es importante que conserve esta información
                </div>
            </div>
        </div>
    {/if}
{/if}